import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Box, TablePagination } from '@mui/material';
import { useState } from 'react';

const columns = [
    { id: 'referrerCustomerID', label: 'Referrer ID', minWidth: 120 },
    { id: 'referrerCustomerName', label: 'Referrer Customer Name', minWidth: 170 },
    { id: 'referrerCustomerLoginUserName', label: 'Referrer LoginUsername', minWidth: 170 },
    { id: 'ambassadorLevelName', label: 'Level', minWidth: 170 },
    // { id: 'becomeAgentDate', label: 'Be Agent Date', minWidth: 170 },
    { id: 'directReferralCount', label: 'Direct Referral Count', minWidth: 170 },
    { id: 'indirectReferralCount', label: 'Indirect Referral Count', minWidth: 170 },
    { id: 'totalReferralCount', label: 'Total Referral Count', minWidth: 170 },
    { id: 'totalValidSalesCount', label: 'Total Valid Sales Count', minWidth: 170 },
    { id: 'totalValidSalesAmount', label: 'Total Valid Sales Amount', minWidth: 170 },
    // { id: 'totalSalesAmount', label: 'Total Sales Amount', minWidth: 170 },
    { id: 'totalIncentiveAmount', label: 'Total Incentive Amount', minWidth: 170 },
];

function StickyHeadTable({ referralTeamSales}) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };


    return (
        <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '50px' }}>
            <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                    {column.label}
                                </TableCell>
                            ))}
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {referralTeamSales.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                    {columns.map((column) => {
                                        let value = row[column.id];
                                        if (column.type && column.type === 'date') {
                                            if (value) {
                                                const timeString12hr = new Date(
                                                    '1970-01-01T' + value.split('T')[1] + 'Z'
                                                ).toLocaleTimeString('en-US', {
                                                    timeZone: 'UTC',
                                                    hour12: true,
                                                    hour: 'numeric',
                                                    minute: 'numeric',
                                                    second: 'numeric'
                                                });
                                                value = `${value.split('T')[0]} ${timeString12hr}`;
                                            }
                                        }
                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                                {typeof value === 'boolean'
                                                    ? value.toString()
                                                    : column.format && typeof value === 'number'
                                                    ? column.format(value)
                                                    : value}
                                                {/* {column.format && typeof value === 'number' ? column.format(value) : value} */}
                                            </TableCell>
                                        );
                                    })}
                                    <TableCell>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px'
                                            }}
                                        >
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={referralTeamSales.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
}

export default StickyHeadTable;
